export interface TermsStatus {
  accepted: boolean;
  id: string;
  termsOfUseId: string;
  updatedDate: number[];
}
